import { Button } from "shared/ui/button"
import { Label } from "shared/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "shared/ui/select"
import type { TemplateField } from "shared/api/templateService"

type TimeParts = {
  hour: string
  minute: string
}

interface PermitTimeFieldProps {
  label: string
  fieldKey: "startTime" | "endTime"
  parts: TimeParts
  generalFieldMap: Record<string, TemplateField | undefined>
  handleTimeHourChange: (key: "startTime" | "endTime", value: string) => void
  handleTimeMinuteChange: (key: "startTime" | "endTime", value: string) => void
  clearTimeField: (key: "startTime" | "endTime") => void
  timeHourOptions: string[]
  timeMinuteOptions: string[]
  hasValue: boolean
  disabled?: boolean
}

export const PermitTimeField = ({
  label,
  fieldKey,
  parts,
  generalFieldMap,
  handleTimeHourChange,
  handleTimeMinuteChange,
  clearTimeField,
  timeHourOptions,
  timeMinuteOptions,
  hasValue,
  disabled = false,
}: PermitTimeFieldProps) => {
  const generalFieldCode = fieldKey === "startTime" ? "STTIME" : "ENTIME"
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-sm text-gray-600">
          {label}
          {generalFieldMap[generalFieldCode]?.required ? <span className="text-red-500">*</span> : null}
        </Label>
        {hasValue ? (
          <Button
            type="button"
            variant="ghost"
            className="h-auto p-0 text-xs text-gray-500 hover:text-gray-700"
            onClick={() => clearTimeField(fieldKey)}
            disabled={disabled}
          >
            ล้างค่า
          </Button>
        ) : null}
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <div className="flex flex-1 items-center gap-2">
          <Select
            value={parts.hour || undefined}
            onValueChange={(value) => handleTimeHourChange(fieldKey, value)}
            disabled={disabled}
          >
            <SelectTrigger className="border-gray-200 bg-gray-50">
              <SelectValue placeholder="ชั่วโมง" />
            </SelectTrigger>
            <SelectContent className="max-h-60 overflow-y-auto">
              {timeHourOptions.map((option) => (
                <SelectItem key={`${fieldKey}-hour-${option}`} value={option}>
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <span className="text-gray-400">:</span>
          <Select
            value={parts.minute || undefined}
            onValueChange={(value) => handleTimeMinuteChange(fieldKey, value)}
            disabled={disabled || !parts.hour}
          >
            <SelectTrigger className="border-gray-200 bg-gray-50">
              <SelectValue placeholder="นาที" />
            </SelectTrigger>
            <SelectContent className="max-h-60 overflow-y-auto">
              {timeMinuteOptions.map((option) => (
                <SelectItem key={`${fieldKey}-minute-${option}`} value={option}>
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  )
}
